import { defaultTheme } from 'react-admin';

/**
 * EKAA Admin Theme
 * Based on React Admin default theme with EKAA brand colors
 */
export const ekaaTheme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      main: '#C97B63',
      light: '#D99B8A',
      dark: '#B56B53',
      contrastText: '#fff',
    },
    secondary: {
      main: '#D4AF37',
      light: '#E0C35C',
      dark: '#B89B2E',
      contrastText: '#000',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    ...defaultTheme.typography,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    ...defaultTheme.components,
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#C97B63',
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '4px 8px',
          '&.RaMenuItemLink-active': {
            backgroundColor: 'rgba(201, 123, 99, 0.12)',
            color: '#C97B63',
          },
        },
      },
    },
  },
};
